import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import {
  Avatar,
  Badge,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Progress,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Tag,
  Typography,
} from "antd";
import {
  ChartColumnStacked,
  Check,
  CheckCircle,
  CircleAlert,
  Edit,
  Filter,
  NotepadText,
  Plus,
  RotateCw,
  Trash2,
  UserRound,
} from "lucide-react";

import { notificationErroInternal, notificationInfo } from "util/api-utils";
import { BRANCH_STORAGE, FONT } from "constants/index";

import { ListEmptyState } from "views/util/emptyState";
import { getUsers } from "services/user/user-service";
import {
  closeTrainingAquatic,
  closeTrainingAquaticBoot,
  doneTrainingAquatic,
  doneTrainingAquaticBoot,
  getPhasesAquatic,
  getUsersReviewsAqua,
  getUsersToTreiningAquatic,
  getUsersToTreiningAquaticBoot,
  openTrainingAquatic,
  saveAnnotationAquatic,
  saveTrainingAqua,
  updateTask,
} from "services/aquatic/aquatic-service";
import { toRoman } from "views/util/roman";
import DrawerApp from "components/drawer-app";
import DetailAquatic from "./managerial-detail-aqua";
import ProgressoRadarChart from "./managerial-chart-aqua";
import FormTrainningBootAqua from "../trainning/trainning-drawer-boot-aqua";
import ManageralAguaFilter from "./manageral-aqua-filter";
import { startSSE, syncEvo } from "services/evo/evo-service";

const { Meta } = Card;
const { confirm } = Modal;
const { TextArea } = Input;

const ManagerialAqua = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(Date.now());
  const [formOpenUser] = Form.useForm();
  const [dataUsers, setDataUsers] = useState([]);
  const [phases, setPhases] = useState([{ subphases: [] }]);
  const [formAnnotation] = Form.useForm();
  const [openDetail, setOpenDetail] = useState(false);
  const [userTrainer, setUserTrainer] = useState(null);
  const [openChart, setOpenChart] = useState(false);
  const [dataBoot, setDataBoot] = useState([]);
  const [activeFilterCount, setActiveFilterCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [openTask, setOpenTask] = useState(false);
  const [userTasks, setUserTask] = useState([]);
  const [phaseActual, setPhaseActual] = useState({
    phase: { subphases: [] },
    subphase: {},
  });
  const [filters, setFilters] = useState({});
  const [syncLoading, setSyncLoading] = useState(false);

  const eventSourcesRef = useRef({}); 

  useEffect(() => {
    refreshData(filters);
    return () => {
      Object.values(eventSourcesRef.current).forEach((es) => es.close());
    };
  }, []);

  useEffect(() => {
    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith("exercise-scroll-aqua")) {
        sessionStorage.removeItem(key);
      }
    });
  }, []);

  const refreshData = async (filter) => {
    await getAll(filter);
  };
  async function getAll(filter) {
    try {
      setLoading(true);
      setLastUpdated(Date.now());
      await Promise.all([
        getData(filter),
        getUsersToTreining(),
        getPhases(),
        getDataBoot(),
      ]);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      setLoading(false);
    }
  }
  const getPhases = async () => {
    try {
      const data = await getPhasesAquatic();
      setPhases(data);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    }
  };

  async function getData(filter) {
    try {
      let param = {};
      if (filter) {
        param = Object.fromEntries(
          Object.entries(filter).filter(([key, value]) => value !== undefined)
        );
      }

      const data = await getUsersToTreiningAquatic(param);
      const dataFinal = [...data.filter((item) => item.isBoot != true)];
      setData(dataFinal);
      if (userTrainer && userTrainer.isBoot != true) {
        const newUser = dataFinal.find((item) => item.id == userTrainer.id);
        setUserTrainer(newUser);
        const phaseActual = findSubphaseById(newUser.training?.subphasesId);
        setPhaseActual(phaseActual)
      }
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    }
  }
  async function getDataBoot() {
    try {
      const data = await getUsersToTreiningAquaticBoot();
      setDataBoot(data);
      if (userTrainer && userTrainer.isBoot == true) {
        const newUser = data.find((item) => item.id == userTrainer.id);
        setUserTrainer(newUser);
      }
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    }
  }
  async function getUsersToTreining() {
    try {
      const users = await getUsers();
      const dataBoot = await getUsersReviewsAqua();
      const dataFinal = [
        ...users.filter((item) => item.isBoot != true),
        ...dataBoot.filter((item) => item.lastReview != null),
      ];
      setDataUsers(dataFinal);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    }
  }
  const DescriptionItem = ({ title, style }) => (
    <div
      className="site-description-item-profile-wrapper"
      style={
        style ? style : { fontFamily: FONT, fontSize: 14, fontWeight: 500 }
      }
    >
      {title}
    </div>
  );

  const saveTask = async (status, taskId, userId) => {
    setLoading(true);

    try {
      await updateTask(taskId + "/" + status, { userId: userId });
      refreshData(filters);

    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  };
  const calcPercent = (tasksDone = [], objectives = []) => {
    const objectiveTaskIds = new Set(
      objectives.flatMap((obj) => obj.tasks?.map((task) => task.id) || [])
    );

    const filteredDone = tasksDone.filter((done) =>
      objectiveTaskIds.has(done.taskId)
    );

    const totalTasks = objectiveTaskIds.size;
    const doneCount = filteredDone.length;

    if (totalTasks === 0) return 0;

    const percent = (doneCount / totalTasks) * 100;

    return Math.round(percent);
  };
  const onCloseDetail = () => {
    setOpenDetail(false);
    setUserTrainer({});
    setPhaseActual({
      phase: { subphases: [] },
      subphase: {},
    })
    refreshData(filters);
    
  };
  const onCloseChart = () => {
    setOpenChart(false);
  };

  async function updateEvo() {
    setSyncLoading(true);
    try {
      const { id } = JSON.parse(localStorage.getItem(BRANCH_STORAGE));
      const param={
        branchId: id
      }
      await syncEvo(param);
      startSSE(id, eventSourcesRef, finishedSync);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
      setSyncLoading(false)
    }
  }
  async function finishedSync(){
    setSyncLoading(false)
    refreshData(filters)
  }

  function getActionCard(user, isBoot) {
    return [
      <div
        onClick={() => {
          openAnotation(user, isBoot);
        }}
      >
        <NotepadText />
      </div>,
      <div
        onClick={() => {
          const phaseActual = findSubphaseById(user.training?.subphasesId);
          setPhaseActual(phaseActual)
          setUserTrainer(user);
          setOpenChart(true);
        }}
      >
        <ChartColumnStacked />
      </div>,
      ...(isBoot != true
        ? [
            <div
              onClick={() => {
                setUserTrainer(user);
                setOpenDetail(true);
              }}
            >
              <Edit />
            </div>,
          ]
        : []),
      <div
        onClick={() => {
          closeTreining(user, isBoot);
        }}
      >
        <Trash2 />
      </div>,
      <div onClick={() => saveTreining(user, isBoot)}>
        <Check />
      </div>,
    ];
  }
  const Exercises = ({ exercises, userId, tasksDone = [] }) => {
    const scrollRef = useRef(null);
    const storageKey = `exercise-scroll-aqua-${userId}`;

    useLayoutEffect(() => {
      const savedScroll = sessionStorage.getItem(storageKey);
      if (scrollRef.current && savedScroll) {
        scrollRef.current.scrollTop = parseInt(savedScroll, 10);
      }
    }, [storageKey]);

    const handleScroll = () => {
      if (scrollRef.current) {
        sessionStorage.setItem(
          storageKey,
          scrollRef.current.scrollTop.toString()
        );
      }
    };
    return (
      <div
        ref={scrollRef}
        onScroll={handleScroll}
        style={{
          maxHeight: 300,
          overflowY: "auto",
          overflowX: "auto",
        }}
        className="custom-scroll"
      >
        {exercises.map((exercise, index) => {
          const allTasksExecuted = exercise.tasks.every((task) =>
            tasksDone.some((done) => done.taskId === task.id)
          );

          const executedTasks = exercise.tasks.filter((task) =>
            tasksDone.some((done) => done.taskId === task.id)
          );
          const highest =
            executedTasks.length > 0
              ? executedTasks.reduce((max, task) =>
                  task.order > max.order ? task : max
                ).order + 1
              : 1;

          const task = exercise.tasks.find((item) => item.order === highest);
          const roman = highest > 0 ? toRoman(highest) : "I";

          return (
            <Col style={{ minWidth: 350 }}>
              <Row key={index}>
                <Col span={24}>
                  <Card
                    style={{
                      backgroundColor: "#ffff",
                      margin: 5,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setUserTask(exercise.tasks);
                      setOpenTask(true);
                    }}
                  >
                    <Row justify="space-between" align="middle">
                      <Col>
                        <DescriptionItem title={exercise.name} />
                      </Col>
                      {!allTasksExecuted && (
                        <Col>
                          <DescriptionItem title={roman} />
                        </Col>
                      )}
                    </Row>
                    {allTasksExecuted && (
                      <DescriptionItem
                        title={"Todas as tarefas concluídas!"}
                        style={{
                          fontFamily: FONT,
                          fontSize: 13,
                          fontWeight: 300,
                          color: "#09ac9c",
                        }}
                      />
                    )}
                    {!allTasksExecuted && (
                      <>
                        <DescriptionItem
                          title={task?.name}
                          style={{
                            fontFamily: FONT,
                            fontSize: 13,
                            fontWeight: 300,
                          }}
                        />
                        <Button
                          type="primary"
                          style={{
                            backgroundColor: "#e6fffb",
                            borderColor: "#fff",
                            color: "#09ac9c",
                            borderRadius: 12,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            saveTask("DONE", task?.id, userId);
                          }}
                          icon={
                            <CheckCircle
                              size={18}
                              style={{
                                marginBottom: "-3px",
                                marginRight: "7px",
                              }}
                            />
                          }
                        >
                          Concluir
                        </Button>
                      </>
                    )}
                  </Card>
                </Col>
              </Row>
            </Col>
          );
        })}
      </div>
    );
  };
  const Tasks = ({ tasks }) => {
    return (
      <div
        style={{
          overflowY: "auto",
          overflowX: "auto",
        }}
        className="custom-scroll"
      >
        {tasks.map((task, index) => {
          const roman = task.order > 0 ? toRoman(task.order) : "I";

          return (
            <Col style={{ minWidth: 350 }}>
              <Row key={index}>
                <Col span={24}>
                  <Card style={{ backgroundColor: "#ffff", margin: 5 }}>
                    <Row justify="space-between" align="middle">
                      <Col>
                        <DescriptionItem title={task.name} />
                      </Col>
                      <Col>
                        <DescriptionItem title={roman} />
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Col>
          );
        })}
      </div>
    );
  };
  const CardTrainings = ({ usersTrainings }) => {
    return usersTrainings.map((user) => {
      const phaseActual = findSubphaseById(user.training?.subphasesId);
      const subPhasesOptions = phaseActual?.phase?.subphases?.map((item) => {
        return { label: item.name, value: item.id, order: item.order };
      });
      const evolution = calcPercent(
        user?.tasksDone ?? [],
        phaseActual?.subphase?.objectives ?? []
      );

      const idSubPhase =
        evolution < 34 ? 1 : evolution > 33 && evolution < 67 ? 2 : 3;
      const subPhaseName = subPhasesOptions?.find(
        (item) => item.order == idSubPhase
      );
      return (
        <Col
          key={user.id}
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          style={{ minWidth: outerWidth < 800 ? 300 : 500 }}
        >
          <Card
            style={{
              width: "100%",
              marginBottom: 16,
              minHeight: 400,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
            actions={getActionCard(user, false)}
          >
            <Meta
              avatar={
                <Avatar
                  src={user?.img}
                  icon={<UserRound size={80} />}
                  size={80}
                />
              }
              title={ user?.isBoot == null ? 
                <div>
                  <p>{user.name}</p>
                  <p style={{ fontSize: 12, fontWeight: 400 }}>
                    Nível: {phaseActual?.phase?.name}
                  </p>
                </div>
                : 
                <div>
                <p>{user.name}</p>
                <p style={{ fontSize: 12, fontWeight: 400 }}>
                  Nível: {phaseActual?.phase?.name} - {subPhaseName?.label}
                </p>
              </div>
              }
              description={
                <div>
                  <Progress
                    percent={calcPercent(
                      user.tasksDone,
                      phaseActual?.subphase?.objectives ?? []
                    )}
                    style={{
                      paddingLeft: 15,
                    }}
                  />

                  <Exercises
                    exercises={phaseActual?.subphase?.objectives ?? []}
                    userId={user.id}
                    tasksDone={user.tasksDone}
                  />
                </div>
              }
            />
          </Card>
        </Col>
      );
    });
  };
  const CardTrainingsBoot = ({ usersTrainings }) => {
    return usersTrainings.map((user) => {
      const zone100A1 = user.review.zone100A1;
      const zone100A1Base = user.review.zone100A1Base;
      const zone100A2 = user.review.zone100A2;
      const zone100A2Base = user.review.zone100A2Base;
      const zone100A3 = user.review.zone100A3;
      const zone100A3Base = user.review.zone100A3Base;
      const zone200A1 = user.review.zone200A1;
      const zone200A1Base = user.review.zone200A1Base;
      const zone200A2 = user.review.zone200A2;
      const zone200A2Base = user.review.zone200A2Base;
      const zone200A3 = user.review.zone200A3;
      const zone200A3Base = user.review.zone200A3Base;
      const zone300A1 = user.review.zone300A1;
      const zone300A1Base = user.review.zone300A1Base;
      const zone300A2 = user.review.zone300A2;
      const zone300A2Base = user.review.zone300A2Base;
      const zone300A3 = user.review.zone300A3;
      const zone300A3Base = user.review.zone300A3Base;
      const [formUser] = Form.useForm();
      formUser.setFieldValue("load", user.training.load);
      formUser.setFieldValue("vmp1", user.training.vmp1);
      formUser.setFieldValue("pse", user.training.pse);
      return (
        <Col
          key={user.id}
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          style={{ minWidth: outerWidth < 800 ? 300 : 500 }}
        >
          <Card
            style={{
              width: "100%",
              marginBottom: 16,
              minHeight: 400,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
            actions={getActionCard(user, true)}
          >
            <Meta
              avatar={
                <Avatar
                  src={user?.img}
                  icon={<UserRound size={80} />}
                  size={80}
                />
              }
              title={
                <div>
                  <p>{user.name}</p>
                </div>
              }
              description={
                <div
                  style={{
                    overflowY: "auto",
                    overflowX: "auto",
                  }}
                  className="custom-scroll"
                >
                  <Col style={{ minWidth: 500 }}>
                    <Row>
                      <Col span={9}>
                        <DescriptionItem title={"Metragens "} />
                      </Col>
                      <Col span={5}>
                        <DescriptionItem title={"A1"} />
                      </Col>
                      <Col span={4}>
                        <DescriptionItem title={"A2"} />
                      </Col>
                      <Col span={4}>
                        <DescriptionItem title={"A3"} />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={9}>
                        <DescriptionItem title={"100"} />
                      </Col>
                      <Col span={5}>
                        <DescriptionItem
                          title={zone100A1 + " - " + zone100A1Base}
                        />
                      </Col>
                      <Col span={4}>
                        <DescriptionItem
                          title={zone100A2 + " - " + zone100A2Base}
                        />
                      </Col>
                      <Col span={4}>
                        <DescriptionItem
                          title={zone100A3 + " - " + zone100A3Base}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={9}>
                        <DescriptionItem title={"200"} />
                      </Col>
                      <Col span={5}>
                        <DescriptionItem
                          title={zone200A1Base + " - " + zone200A1}
                        />
                      </Col>
                      <Col span={4}>
                        <DescriptionItem
                          title={zone200A2 + " - " + zone200A2Base}
                        />
                      </Col>
                      <Col span={4}>
                        <DescriptionItem
                          title={zone200A3 + " - " + zone200A3Base}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={9}>
                        <DescriptionItem title={"300+"} />
                      </Col>
                      <Col span={5}>
                        <DescriptionItem
                          title={zone300A1Base + " - " + zone300A1}
                        />
                      </Col>
                      <Col span={4}>
                        <DescriptionItem
                          title={zone300A2 + " - " + zone300A2Base}
                        />
                      </Col>
                      <Col span={4}>
                        <DescriptionItem
                          title={zone300A3 + " - " + zone300A3Base}
                        />
                      </Col>
                    </Row>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={24}>
                        <DescriptionItem title={"Treino"} />
                      </Col>
                    </Row>
                    <Form form={formUser} layout="vertical">
                      <Row gutter={16}>
                        <Col span={8}>
                          <Form.Item name="load" label="Metragem/Dia">
                            <InputNumber
                              style={{ fontFamily: FONT, width: "100%" }}
                              onBlur={() =>
                                setTraining(formUser, user.training.id)
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item name="vmp1" label="Tempo (min,seg)">
                            <InputNumber
                              decimalSeparator=","
                              style={{ fontFamily: FONT, width: "100%" }}
                              onBlur={() =>
                                setTraining(formUser, user.training.id)
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={7}>
                          <Form.Item name="pse" label="PSE">
                            <InputNumber
                              style={{ fontFamily: FONT, width: "100%" }}
                              onBlur={() =>
                                setTraining(formUser, user.training.id)
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                </div>
              }
            />
          </Card>
        </Col>
      );
    });
  };

  const formatTime = (date) => {
    if (!date) return "Nunca atualizado";
    return new Intl.DateTimeFormat("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(date);
  };

  function updateList() {
    const idsToRemove = new Set([
      ...data.map((item) => item.id),
      ...dataBoot.map((item) => item.id),
    ]);
    const result = dataUsers.filter((item) => !idsToRemove.has(item.id));

    if (result.length == 0) {
      notificationInfo(
        "Todos os alunos disponíveis estão no painel ou com cíclos finalizados"
      );
      return;
    }

    const resultOrder = result.sort((a, b) => a.name.localeCompare(b.name));
    openTraing(resultOrder);
  }

  function openTraing(result) {
    confirm({
      title: (
        <div>
          <CircleAlert size={22} style={{ marginBottom: "-5px" }} />
          <span style={{ marginLeft: "10px", fontFamily: FONT }}>
            Qual Aluno ?
          </span>
          <div style={{ marginTop: "10px" }}>
            <Form form={formOpenUser} layout="vertical">
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item name="userOpen">
                    <Select
                      mode="multiple"
                      showSearch
                      optionFilterProp="children"
                    >
                      {result.map((item) => {
                        return <Option value={item.id}>{item.name}</Option>;
                      })}
                    </Select>
                  </Form.Item>
                  <Form.Item name="typeOpen">
                    <Radio.Group
                      options={[
                        { label: "Último Treino", value: "LAST" },
                        { label: "Novo Treino", value: "NEW" },
                      ]}
                      defaultValue={"NEW"}
                      optionType="button"
                      buttonStyle="solid"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      ),
      icon: null,
      okText: "Selecionar",
      cancelText: "Cancelar",
      async onOk() {
        setLoading(true);

        const users = formOpenUser.getFieldValue("userOpen");

        const usersNotBoot = [];
        const usersBoot = [];
        users?.forEach((userId) => {
          const usersNotBootId = dataUsers.filter(
            (d) => d.id == userId && d.isBoot != true
          );
          const usersBootId = dataUsers.filter(
            (d) => d.id == userId && d.isBoot == true
          );
          if (usersNotBootId.length > 0) {
            usersNotBoot.push(userId);
          }
          if (usersBootId.length > 0) {
            usersBoot.push(userId);
          }
        });

        if (usersNotBoot.length == 0 && usersBoot.length == 0) {
          notificationInfo("É nescessário informar o aluno");
          setLoading(false);
          return;
        }

        const typeOpen = formOpenUser.getFieldValue("typeOpen");
        try {
          if (usersNotBoot.length > 0) {
            const objNotBoot = {
              users: usersNotBoot,
              typeOpen: typeOpen ?? "NEW",
              typeUser: "NOT_BOOT",
            };
            await openTrainingAquatic(objNotBoot);
          }
          if (usersBoot.length > 0) {
            const objUsersBoot = {
              users: usersBoot,
              typeOpen: typeOpen ?? "NEW",
              typeUser: "BOOT",
            };

            await openTrainingAquatic(objUsersBoot);
          }
          refreshData(filters);
        } catch (error) {
          notificationErroInternal(
            "Aconteceu um erro inesperado, por favor, tente mais tarde."
          );
        } finally {
          setLoading(false);
          formOpenUser.resetFields();
        }
      },
      onCancel() {
        formOpenUser.resetFields();
      },
    });
  }

  const findSubphaseById = (subphaseId) => {
    for (const phase of phases) {
      const found = phase.subphases.find((sub) => sub.id === subphaseId);
      if (found) {
        return { phase, subphase: found };
      }
    }
    return null;
  };

  function openAnotation(user, isBoot) {
    const annotation = user.training.annotation;

    formAnnotation.setFieldValue("userAnnotation", annotation);
    confirm({
      title: (
        <div>
          <CircleAlert size={22} style={{ marginBottom: "-5px" }} />
          <span style={{ marginLeft: "10px", fontFamily: FONT }}>
            Anotações do Treino
          </span>
          <div style={{ marginTop: "10px" }}>
            <Form form={formAnnotation} layout="vertical">
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item name="userAnnotation">
                    <TextArea rows={8} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      ),
      icon: null,
      okText: "Salvar",
      cancelText: "Cancelar",
      async onOk() {
        setLoading(true);

        const obj = {
          trainingId: user.training.id,
          annotation: formAnnotation.getFieldValue("userAnnotation"),
          isBoot: isBoot,
        };
        try {
          await saveAnnotationAquatic(obj);
          refreshData(filters);
        } catch (error) {
          notificationErroInternal(
            "Aconteceu um erro inesperado, por favor, tente mais tarde."
          );
        } finally {
          setLoading(false);
          formAnnotation.resetFields();
        }
      },
      onCancel() {
        formAnnotation.resetFields();
      },
    });
  }

  async function closeTreining(user, isBoot) {
    setLoading(true);
    try {
      if (isBoot) {
        await closeTrainingAquaticBoot(user.training.id);
      } else {
        await closeTrainingAquatic(user.training.id);
      }
      refreshData(filters);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  }

  async function saveTreining(user, isBoot) {
    setLoading(true);
    try {
      if (isBoot) {
        await doneTrainingAquaticBoot(user.training.id);
      } else {
        await doneTrainingAquatic(user.training.id);
      }
      refreshData(filters);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  }

  function setTraining(formUser, trainingId) {
    setLoading(true);
    const obj = {
      trainingId: trainingId,
      load: formUser.getFieldValue("load"),
      vmp1: formUser.getFieldValue("vmp1"),
      pse: formUser.getFieldValue("pse"),
    };
    saveTrainingAqua(obj)
      .then(() => {
        refreshData(filters);
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  const showDrawer = () => setOpen(true);
  const closeDrawer = () => setOpen(false);
  const closeDrawerTask = () => {
    setUserTask([]);
    setOpenTask(false);
  };

  const findData = async (filter) => {
    const filledCount = Object.entries(filter).reduce((count, [key, value]) => {
      if (Array.isArray(value)) return count + (value.length > 0 ? 1 : 0);
      if (typeof value === "string")
        return count + (value.trim() !== "" ? 1 : 0);
      if (dayjs.isDayjs(value)) return count + 1;
      if (value !== null && value !== undefined) return count + 1;
      return count;
    }, 0);
    setActiveFilterCount(filledCount);
    setFilters(filter)
    closeDrawer();
    await refreshData(filter);
  };
  return (
    <div className="container-managerial">
      <Row gutter={24} style={{ padding: "10px" }}>
        <Space>
          <Button
          loading={syncLoading}
            style={{
              fontFamily: FONT,
              background: "#09ac9c",
            }}
            type="primary"
            icon={
              <RotateCw
                size={18}
                style={{ marginBottom: "-3px", marginRight: "7px" }}
              />
            }
            onClick={() => {
              updateEvo();
            }}
          >
            Sincronizar EVO
          </Button>
          <Button
            style={{
              fontFamily: FONT,
            }}
            type="primary"
            icon={
              <Plus
                size={18}
                style={{ marginBottom: "-3px", marginRight: "7px" }}
              />
            }
            onClick={updateList}
          >
            Abrir Treino
          </Button>
          <Badge count={activeFilterCount} offset={[-4, 4]}>
            <Button
              style={{
                fontFamily: FONT,
                color: "#000000",
                backgroundColor: "#ffffff",
              }}
              type="primary"
              icon={
                <Filter
                  size={18}
                  style={{ marginBottom: "-3px", marginRight: "7px" }}
                />
              }
              onClick={showDrawer}
            >
              Filtros
            </Button>
          </Badge>
        </Space>
      </Row>
      <Row>
        <div style={{ fontFamily: FONT, fontSize: 12, marginBottom: 15 }}>
          Última atualização: {formatTime(lastUpdated)}{" "}
        </div>
      </Row>
      <Spin spinning={loading}>
        {data.length > 0 && (
          <Row gutter={16}>
            <CardTrainings usersTrainings={data} />
          </Row>
        )}
        {dataBoot.length > 0 && (
          <>
            <Divider />
            <Typography.Title
              level={5}
              style={{ margin: 0, textAlign: "center", color: "#979993" }}
            >
              Metódo Atleta
            </Typography.Title>
            <Divider />

            <Row gutter={16}>
              <CardTrainingsBoot usersTrainings={dataBoot} />
            </Row>
          </>
        )}

        {dataBoot.length == 0 && data.length == 0 && (
          <Row gutter={16}>
            <div style={{ textAlign: "center", width: "100%" }}>
              <ListEmptyState subTitle={"A sessão de treino está vazia"} />
            </div>
          </Row>
        )}
      </Spin>
      <DrawerApp
        open={openDetail}
        onClose={onCloseDetail}
        title={userTrainer?.name}
        body={
          <DetailAquatic
            user={userTrainer}
            findSubphaseById={findSubphaseById}
            calcPercent={calcPercent}
            allPhases={phases}
            saveTask={saveTask}
          />
        }
        size={"large"}
        isOnlyView={true}
        width={outerWidth < 501 ? "100%" : "65%"}
      />
      <DrawerApp
        open={openChart}
        onClose={onCloseChart}
        title={userTrainer?.name}
        body={
          userTrainer?.isBoot != true ? (
            <ProgressoRadarChart
            phases={phases.filter((f) => f.id == phaseActual?.phase?.id)}
            taskDone={userTrainer?.tasksDone ?? []}
            />
          ) : (
            <FormTrainningBootAqua user={userTrainer} />
          )
        }
        size={"large"}
        isOnlyView={true}
        width={outerWidth < 501 ? "100%" : "65%"}
      />
      <DrawerApp
        open={open}
        onClose={closeDrawer}
        title={"Filtros"}
        body={<ManageralAguaFilter findData={findData} />}
        width={outerWidth < 501 ? "100%" : "30%"}
        isOnlyView={true}
      />
      <DrawerApp
        open={openTask}
        onClose={closeDrawerTask}
        title={"Atividades"}
        body={<Tasks tasks={userTasks} />}
        width={outerWidth < 501 ? "100%" : "40%"}
        isOnlyView={true}
      />
    </div>
  );
};

export default ManagerialAqua;
